<template>
    <div class="general-working-info">
        <div class="row">
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Ngày nhận việc</label>
                <input type="text" v-model="dataGeneralWorking.start_date" class="form-control" disabled>
            </div>
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Số tháng thử việc</label>
                <input type="text" v-model="dataGeneralWorking.probation_months" class="form-control" disabled>
            </div>
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Ngày kết thúc thử việc</label>
                <input type="text" v-model="dataGeneralWorking.probation_end_date" class="form-control" disabled>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Ngày bắt đầu chính thức</label>
                <input type="text" v-model="dataGeneralWorking.official_start_date" class="form-control" disabled>
            </div>
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Cơ chế thu nhập</label>
                <input type="text" v-model="dataGeneralWorking.income_scheme" class="form-control" disabled>
            </div>
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Ngày bắt đầu góp vốn</label>
                <input type="text" v-model="dataGeneralWorking.equity_start_date" class="form-control" disabled>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Mức lương thực tế theo vị trí level</label>
                <input
                    type="text"
                    class="form-control"
                    :value="formatSalary(dataGeneralWorking.salary)"
                    disabled
                >

            </div>
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Mức lương cơ bản (BHXH)</label>
                <input
                    type="text"
                    class="form-control"
                    :value="formatSalary(dataGeneralWorking.salary_social_insurance)"
                    disabled
                >
            </div>
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Lịch làm việc</label>
                <el-select class="w-100" v-model="dataGeneralWorking.work_calendar" placeholder="Chọn lịch làm việc">
                    <el-option v-for="item in workCalendars" :key="item.id" :label="item.value"
                               :value="item.id">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Giờ checkin</label>
                <el-time-select
                    class="w-100"
                    v-model="dataGeneralWorking.check_in_time"
                    :picker-options="{
                                start: '06:00',
                                step: '00:15',
                                end: '23:30'
                              }"
                    placeholder="Chọn giờ checkin">
                </el-time-select>
            </div>
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Giờ checkout</label>
                <el-time-select
                    class="w-100"
                    v-model="dataGeneralWorking.check_out_time"
                    :picker-options="{
                                start: '06:00',
                                step: '00:15',
                                end: '23:30'
                              }"
                    placeholder="Chọn giờ checkout">
                </el-time-select>
            </div>
            <div class="col-12 col-md-6 col-xl-4 mb-3">
                <label for="">Khối</label>
                <el-select v-model="dataGeneralWorking.division_type" filterable class="w-100" placeholder="Khối" disabled
                           clearable>
                    <el-option v-for="item in blocks" :key="item.id" :label="item.name" :value="item.id">
                        <span style="float: left">{{ item.name }}</span>
                    </el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
import {GENERAL_WORKING_INFO} from "../../../../core/services/store/profile.module";
import {mapGetters, mapState} from "vuex";

export default {
    name: "GeneralWorkingInfo",
    data() {
        return {
            loading: false,
            dataGeneralWorking: {},
            workCalendars: [
                {
                    id: 0,
                    value: 'Thứ 2 - Thứ 6'
                },
                {
                    id: 1,
                    value: 'Thứ 2 - Thứ 7'
                },
                {
                    id: 2,
                    value: 'Khác'
                }
            ],
            blocks: [
                {
                    id: 1,
                    name: 'BO trụ sở'
                },
                {
                    id: 2,
                    name: 'BO cơ sở'
                },
                {
                    id: 3,
                    name: 'Kinh doanh'
                },
                {
                    id: 4,
                    name: 'Giáo viên'
                }
            ]
        }
    },
    mounted() {
        this.getGeneralWorking();
    },
    methods: {
        getGeneralWorking() {
            this.$store.dispatch(GENERAL_WORKING_INFO, this.currentUser.id).then((res) => {
                this.dataGeneralWorking = res.data
            });
        },
        formatSalary(value) {
            if (!value && value !== 0) return ''
            return new Intl.NumberFormat('vi-VN', {
                style: 'currency',
                currency: 'VND'
            }).format(value)
        }
    },
    computed: {
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(['currentUser'])
    }
}
</script>

<style scoped>
.bg-violet {
    background-color: #5E00B6;
}

.general-working-info {
    width: 100%;
}

.general-working-info label {
    word-break: break-word;
}

.general-working-info /deep/ .el-select,
.general-working-info /deep/ .el-date-editor {
    width: 100%;
}
</style>
